import React from 'react'
import { FormattedDate } from 'react-intl'

import { convertUTCToISO8601format } from '@lyrahealth-inc/shared-app-logic/src/features/common/utils/convertUTCToISO8601format'
import { Outcome } from '@lyrahealth-inc/shared-app-logic/src/models/outcome/Outcome'

const CustomTick: React.FC<CustomTickProps> = ({ x, y = 0, height, width, textAnchor, payload, data, fillColor }) => {
  const topMargin = 25
  const tickX = x ?? payload?.tickCoord ?? payload?.coordinate

  const renderDescription = () => {
    if (payload?.value === data[data.length - 1]?.response_date) {
      return 'Baseline'
    } else if (payload?.value === data[0]?.response_date) {
      return 'Most Recent'
    }
    return ''
  }

  return (
    <text
      textAnchor={textAnchor}
      height={height}
      width={width}
      y={y + topMargin}
      x={tickX}
      {...(!!fillColor && { style: { fill: fillColor } })}
    >
      <tspan x={tickX}>
        <FormattedDate
          value={convertUTCToISO8601format(payload?.value || '')}
          year='numeric'
          month='2-digit'
          day='2-digit'
        />
      </tspan>
      <tspan x={tickX} dy='20px'>
        {renderDescription()}
      </tspan>
    </text>
  )
}

type CustomTickProps = {
  x?: number
  y?: number
  height?: number
  width?: number
  textAnchor?: React.SVGProps<SVGTextElement>['textAnchor']
  payload?: Tick
  data: Outcome[]
  fillColor?: string
}

type Tick = {
  coordinate: number
  isShow: boolean
  offset: number
  tickCoord: number
  value: string
}

export default CustomTick
